import { Scale } from '@arpeggi/shared'
import { Instance, types } from 'mobx-state-tree'
import { ForDirectExtend } from '../../../../features/mobx'

const _MelodicLoopSettingsStore = types
  .model({
    // Key and scale determine which notes to show.
    scale: Scale.CHROMATIC,
    key: 0,

    // These only get set when serializing.
    lowNote: 0,
    bitsPerNote: 0
  })
  .actions((self) => {
    return {}
  })

interface MelodicLoopSettingsStoreType extends ForDirectExtend<typeof _MelodicLoopSettingsStore> {}
export const MelodicLoopSettingsStore: MelodicLoopSettingsStoreType = _MelodicLoopSettingsStore

export interface IMelodicLoopSettingsStore
  extends ForDirectExtend<Instance<typeof MelodicLoopSettingsStore>> {}
